// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TriangleFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TriangleFilledIcon" ref={forwardedRef} {...props}>
      <path d="m10 3 7.5 14h-15z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const TriangleFilledIcon = /* @__PURE__ */ Object.assign(
  TriangleFilledIconComponent,
  { displayName: 'TriangleFilledIcon' },
);
